import { render, staticRenderFns } from "./PlayersPaymentRestores.vue?vue&type=template&id=bae947ec&"
import script from "./PlayersPaymentRestores.vue?vue&type=script&lang=js&"
export * from "./PlayersPaymentRestores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports